import Backbone from "backbone";

import * as mustcache from "mustcache";

const PaginationControlsView = Backbone.View.extend({
  events: {
    "click .next": "next",
    "click .prev": "prev",
  },
  tagName: "select",
  className: "selectView",
  render: function () {
    const templateData: { [key: string]: any } = {
      from: this.model.searchQuery.get("from") + 1,
      totalCount: this.model.totalCount,
    };

    templateData.to = templateData.from + this.model.length - 1;

    if (this.model.totalCount > 0) {
      templateData.wordsExist = true;
    }

    if (templateData.to < this.model.totalCount) {
      templateData.showNext = true;
    }
    if (templateData.from > 1) {
      templateData.showPrev = true;
    }

    this.$el.html(mustcache.render("paginationControls", templateData));
  },
  initialize: function () {
    const that = this;
    this.listenTo(this.model, "reset add remove", () => {
      that.render();
    });
    this.listenTo(this.model, "wordsDeleted", () => {
      that.render();
    });
    this.render();
  },
  suppressUpdates: function (callback) {
    this._suppressUpdates = true;
    callback();
    this._suppressUpdates = false;
  },
  prev: function () {
    const that = this;
    this.model.fetchPrev({
      success: function () {
        that.render();
      },
    });
  },
  next: function () {
    const that = this;
    this.model.fetchNext({
      success: function () {
        that.render();
      },
    });
  },
});

export default PaginationControlsView;
